import { Appointment, ParchiPatient } from "@elixir/types";
import { GET_PARCHI_HOST } from "../constants/env";
import fetch from "../fetch-client";

export default async function sendVisitSms({
  aid,
}: {
  aid: Appointment["aid"];
}): Promise<{ isSent: boolean; status?: string; wpString?: string }> {
  try {
    const PARCHI_HOST = GET_PARCHI_HOST();
    let endpoint = `${PARCHI_HOST}/service/sendvisitsms/${aid}`;
    const res = await fetch(endpoint, {
      method: "GET",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return res.json();
  } catch (e) {
    return { isSent: false };
  }
}
